import React from 'react'
import { Box, Flex, Heading, Stack, Text } from '@chakra-ui/react'
import { formatCurrency, type DonationEvent } from '@kuow/core'
import { eventMethodLabel, eventTitle, formatActivityDate } from './activityFormat'

export interface ReceiptBodyProps {
  event: DonationEvent
  memberName: string
}

const Row: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <Flex justify="space-between" gap={4} fontSize="sm">
    <Text color="fg.muted">{label}</Text>
    <Text fontWeight="semibold" textAlign="right">{children}</Text>
  </Flex>
)

export const ReceiptBody: React.FC<ReceiptBodyProps> = ({ event, memberName }) => {
  const statusLabel = event.status === 'refunded' ? 'Refunded' : 'Completed'
  const method = eventMethodLabel(event)
  const receiptNumber = event.detail?.receipt_id
  return (
    <Stack gap={5} bg="bg.panel" borderWidth="1px" borderColor="bg.muted" borderRadius="l3" p={6}>
      <Stack gap={1}>
        <Heading as="h2" size="lg">{formatCurrency(event.amount ?? 0, true)}</Heading>
        <Text fontSize="sm" color="fg.muted">
          KUOW - {eventTitle(event)}{event.monthly ? ' · Recurring Payment' : ' · Single Payment'}
        </Text>
      </Stack>
      <Box height="1px" bg="bg.muted" />
      <Stack gap={2}>
        <Row label="Date">{formatActivityDate(event.occurred_at)}</Row>
        <Row label="Status">{statusLabel}</Row>
        <Row label="Member Name">{memberName}</Row>
        
        {method ? <Row label="Payment method">{method}</Row> : null}
        {receiptNumber ? <Row label="Donation">{receiptNumber}</Row> : null}
        {event.gift_name ? <Row label="Gift">{event.gift_name}</Row> : null}
      </Stack>
    </Stack>
  )
}
